import i18n from '@/vms/lang'

const title = '活动陈列管理系统';

export default function getPageTitle(key) {
  const hasKey = i18n.te(`menu.${key}`);
  if (hasKey) {
    const pageName = i18n.t(`menu.${key}`);
    return `${pageName} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/vms/utils/get-page-title.js